import React, { Component } from "react";
import { connect } from "react-redux";
import Results from "../../components/Backlinks/BacklinksResults";
import { fetchResource } from "../../store/backlinks/operations";
import {
  getOffset,
  getResults,
  isFetchingResults,
  isFirstFetch,
  getHasMore,
  getResultsToExportAsJson,
  getResultsToExportAsCsv
} from "../../store/backlinks/selectors";

class BacklinksResults extends Component {
  componentDidMount = _ => {
    this.props.fetchResource(this.props.resourceType, this.props.domain, this.props.orderBy, this.props.orderDir);
  };

  onLoadMore = _ => {
    this.props.fetchResource(
      this.props.resourceType,
      this.props.domain,
      this.props.orderBy,
      this.props.orderDir,
      this.props.offset
    );
  };

  render() {
    return (
      <Results
        isLoading={this.props.isLoading}
        results={this.props.results}
        onLoadMore={this.onLoadMore}
        isFirstFetch={this.props.isFirstFetch}
        hasMore={this.props.hasMore}
        resourceType={this.props.resourceType}
        backlinksAsJson={this.props.backlinksAsJson}
        backlinksAsCsv={this.props.backlinksAsCsv}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { domain, resourceType, orderBy, orderDir } = ownProps;
  const sortBy = `${orderBy}_${orderDir}`;

  return {
    offset: getOffset(state, domain, resourceType, sortBy),
    results: getResults(state, domain, resourceType, sortBy),
    isLoading: isFetchingResults(state, domain, resourceType, sortBy),
    isFirstFetch: isFirstFetch(state, domain, resourceType, sortBy),
    hasMore: getHasMore(state, domain, resourceType, sortBy),
    backlinksAsJson: getResultsToExportAsJson(state, domain, resourceType, sortBy),
    backlinksAsCsv: getResultsToExportAsCsv(state, domain, resourceType, sortBy)
  };
};

export default connect(mapStateToProps, { fetchResource })(BacklinksResults);
